// Port tipado de src/js/session.js (Fase 1.0 do MODERNIZACAO.md).
// Mesmas semânticas do legado (JSON transparente, clear preserva 'alertas').
// O legado continua carregando src/js/session.js como global até a
// migração das páginas; manter os dois em sincronia até o cutover.
// Com a flag cookieAuth ligada (Fase 2), token/refreshToken ficam só nos
// cookies httpOnly e não são persistidos aqui.

import { isEnabled } from '../config/flags'

export interface DadosAutenticacao {
  token: string
  refreshToken: string
  expireAt: string | number
  usuario: { login: string; [campo: string]: unknown }
}

export function set(key: string, value: unknown): void {
  const serialized = typeof value === 'object' ? JSON.stringify(value) : String(value)
  localStorage.setItem(key, serialized)
}

export function get<T = unknown>(key: string): T | string | null {
  const value = localStorage.getItem(key)
  if (value === null) {
    return null
  }
  try {
    return JSON.parse(value) as T
  } catch {
    return value
  }
}

export function getAll(): Record<string, unknown> {
  const all: Record<string, unknown> = {}
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key !== null) {
      all[key] = get(key)
    }
  }
  return all
}

// Com a flag cookieAuth ligada, token e refreshToken vivem só nos cookies
// httpOnly emitidos pelo backend — não são persistidos no localStorage,
// onde ficariam expostos a XSS. Espelha Session._persistirTokens do legado.
function persistirTokens(): boolean {
  return !isEnabled('cookieAuth')
}

export function init(dados: DadosAutenticacao): void {
  set('authenticated', true)
  set('expireAt', dados.expireAt)
  if (persistirTokens()) {
    set('token', dados.token)
    set('refreshToken', dados.refreshToken)
  }
  set('_usuario', dados.usuario)
  set('login', dados.usuario.login)
}

export function refresh(
  dados: Pick<DadosAutenticacao, 'token' | 'refreshToken' | 'expireAt'>
): void {
  set('authenticated', true)
  set('expireAt', dados.expireAt)
  if (persistirTokens()) {
    set('token', dados.token)
    set('refreshToken', dados.refreshToken)
  }
}

export function remove(key: string): void {
  localStorage.removeItem(key)
}

export function clear(): void {
  for (const key of Object.keys(getAll())) {
    if (key !== 'alertas') {
      remove(key)
    }
  }
}
